import { useTheme } from '@mui/material';
const useFullScreenViewStyles = () => {
    const theme = useTheme();
    return {
        IncidentFullViewContainer: {
            display: 'flex',
            flexDirection: 'column',
            background: theme.palette.common.black,
            flex: 1,
            position: 'fixed',
            inset: 0,
            py: 2,
            zIndex: 1,
        },
        Header: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2
        },
        HeaderTitleChip: {
            display: 'inline-flex',
            flexShrink: 0,
            background: 'transparent',
            color: theme.palette.common.white
        },
        ImageViewer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            "img": {
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
            }
        }
    };
};
export default useFullScreenViewStyles;
